const locales = {
  en: 'English',
};
export default locales;
